<template>
  <div class="page">
    <!--        <div class="absBack">-->
    <!--            <div onclick="window.history.back()">-->
    <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
    <!--            </div>-->
    <!--        </div>-->

    <!--        <h1 class="myTitle tablet">Impressum</h1>-->

    <v-container grid-list-xl>

      <div class="text-center mt-5">

        <h2>Kellnerruf</h2>
        <h3 class="mb-8" v-if="selectedService.length > 0">"{{ selectedService }}"</h3>

        <div v-if="currentStep === 1">

          <!--                    <div class="text-center mt-7 mb-5">-->

          <!--                        <h4>Welchen Wunsch hast Du?</h4>-->
          <div class="spacer-15"></div>
          <!--                    </div>-->

          <!--            Service / Zahlung bar / Zahlung Karte bitte-->

          <v-layout row wrap>
            <!--                        <v-flex xs12 sm6 md4>-->
            <!--                            <CategoryCard :nomargin="true" class="" label="Bestellung"-->
            <!--                                          @click.native.passive="signal('Bestellung')">-->
            <!--                            </CategoryCard>-->
            <!--                            &lt;!&ndash;                            <BrandButton class="" content="Service"&ndash;&gt;-->
            <!--                            &lt;!&ndash;                                         @click.native.passive.stop="signal('Service')"></BrandButton>&ndash;&gt;-->
            <!--                        </v-flex>-->
            <v-flex xs12 sm6 md4>
              <!--                            <CategoryCard :nomargin="true" class="" label="Zahlung bar"-->
              <!--                                          @click.native.passive="signal('Zahlung bar')">-->
              <!--                            </CategoryCard>-->

              <CategoryCard class="pointer" @click.native.passive="clickPayOption('Zahlung bar')"
                            label="Zahlung bar" :nomargin="false" icon="mdi-cash"></CategoryCard>

            </v-flex>
            <v-flex xs12 sm6 md4>
              <!--                            <CategoryCard :nomargin="true" class="" label="Zahlung Kreditkarte"-->
              <!--                                          @click.native.passive="signal('Zahlung Kreditkarte')">-->
              <!--                            </CategoryCard>-->
              <CategoryCard class="pointer" @click.native.passive="clickPayOption('Zahlung Kreditkarte')"
                            label="Zahlung Kreditkarte" :nomargin="false" icon="mdi-credit-card"></CategoryCard>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <!--                            <CategoryCard :nomargin="true" class="" label="Zahlung EC-Karte"-->
              <!--                                          @click.native.passive="signal('Zahlung EC-Karte')">-->
              <!--                            </CategoryCard>-->
              <CategoryCard class="pointer" @click.native.passive="clickPayOption('Zahlung EC-Karte')"
                            label="Zahlung EC-Karte" :nomargin="false" icon="mdi-credit-card-outline"></CategoryCard>
              <!--                            <v-btn block class="text-none btn-df mt-2"-->
              <!--                                   @click.native.passive.stop="signal('Zahlung EC-Karte')">-->
              <!--                                Zahlung EC-Karte-->
              <!--                            </v-btn>-->
              <!--                            <BrandButton class="" content="Zahlung EC-Karte"-->
              <!--                                                                     @click.native.passive.stop="signal('Zahlung EC-Karte')"></BrandButton>-->
            </v-flex>
            <!--                        <v-flex xs12 sm6 md4>-->
            <!--                            &lt;!&ndash;                            <CategoryCard :nomargin="true" class="" label="Kein Wunsch"&ndash;&gt;-->
            <!--                            &lt;!&ndash;                                          @click.native.passive="gotoHome">&ndash;&gt;-->
            <!--                            &lt;!&ndash;                            </CategoryCard>&ndash;&gt;-->
            <!--                            <BrandButton class="" content="Eine Frage stellen"-->
            <!--                                         @click.native.passive.stop="askQuestion"></BrandButton>-->
            <!--                            &lt;!&ndash;                            <v-btn block class="text-none btn-df mt-2"&ndash;&gt;-->
            <!--                            &lt;!&ndash;                                   @click.native.passive.stop="gotoHome">&ndash;&gt;-->
            <!--                            &lt;!&ndash;                                Kein Wunsch&ndash;&gt;-->
            <!--                            &lt;!&ndash;                            </v-btn>&ndash;&gt;-->
            <!--                            &lt;!&ndash;                                                        <BrandButton class="" content="Kein Wunsch"&ndash;&gt;-->
            <!--                            &lt;!&ndash;                                                                     @click.native.passive.stop="gotoHome"></BrandButton>&ndash;&gt;-->
            <!--                        </v-flex>-->
            <v-flex xs12 sm6 md4>
              <!--                            <CategoryCard :nomargin="true" class="" label="Zahlung EC-Karte"-->
              <!--                                          @click.native.passive="signal('Zahlung EC-Karte')">-->
              <!--                            </CategoryCard>-->
              <CategoryCard class="pointer" @click.native.passive="signal('Kellner bitte')"
                            label="Kellner rufen" :nomargin="false" pngicon="waiter" :inverse="true"></CategoryCard>
              <!--                            <v-btn block class="text-none btn-df mt-2"-->
              <!--                                   @click.native.passive.stop="signal('Zahlung EC-Karte')">-->
              <!--                                Zahlung EC-Karte-->
              <!--                            </v-btn>-->
              <!--                            <BrandButton class="" content="Zahlung EC-Karte"-->
              <!--                                                                     @click.native.passive.stop="signal('Zahlung EC-Karte')"></BrandButton>-->
            </v-flex>
            <!--                        <v-flex xs12 sm6 md4>-->
            <!--                            &lt;!&ndash;                            <CategoryCard :nomargin="true" class="" label="Kein Wunsch"&ndash;&gt;-->
            <!--                            &lt;!&ndash;                                          @click.native.passive="$ebus.$emit('gotoStart')">&ndash;&gt;-->
            <!--                            &lt;!&ndash;                            </CategoryCard>&ndash;&gt;-->
            <!--                            <BrandButton class="" content="Zurück"-->
            <!--                                         @click.native.passive.stop="$ebus.$emit('gotoStart')"></BrandButton>-->
            <!--                            &lt;!&ndash;                            <v-btn block class="text-none btn-df mt-2"&ndash;&gt;-->
            <!--                            &lt;!&ndash;                                   @click.native.passive.stop="gotoHome">&ndash;&gt;-->
            <!--                            &lt;!&ndash;                                Kein Wunsch&ndash;&gt;-->
            <!--                            &lt;!&ndash;                            </v-btn>&ndash;&gt;-->
            <!--                            &lt;!&ndash;                                                        <BrandButton class="" content="Kein Wunsch"&ndash;&gt;-->
            <!--                            &lt;!&ndash;                                                                     @click.native.passive.stop="$ebus.$emit('gotoStart')"></BrandButton>&ndash;&gt;-->
            <!--                        </v-flex>-->
          </v-layout>
        </div>

        <!--                <div class="pt-8">-->

        <!--                    <v-btn class="orderBtn"-->
        <!--                           color="green"-->
        <!--                           dark-->
        <!--                           block-->
        <!--                           @click.native.passive="weiter">-->
        <!--                        <v-icon left class="">mdi-send</v-icon>-->
        <!--                        Los geht's-->
        <!--&lt;!&ndash;                        v-if="captchaInput.length===4"&ndash;&gt;-->
        <!--                    </v-btn>-->

        <!--                    <v-btn c @click.native.passive="$ebus.$emit('gotoStart')" class="mt-5 text-none btn-df okBtn">-->
        <!--                        Zurück-->
        <!--                    </v-btn>-->
        <!--                </div>-->

        <!--                <div v-show="currentStep === 2">-->
        <!--                    <h4 class="mt-1 mb-4">Bitte gib folgende Buchstaben ein, um den Kellner zu rufen:</h4>-->
        <!--                    <div class="d-inline-block">-->
        <!--                        <div class="d-flex align-content-center">-->
        <!--                            &lt;!&ndash;                        <canvas id="captchaUmage" width="150" height="35"></canvas>&ndash;&gt;-->
        <!--                            <img id="captchaUmage" style="width:200px; height: 50px">-->
        <!--                            <div style="width: 15px"></div>-->
        <!--                            <v-btn icon @click.native.passive="reloadCaptcha"-->
        <!--                                   style="height: 100%; align-self: center;">-->
        <!--                                <v-icon class="myBlack" large>mdi-reload</v-icon>-->
        <!--                            </v-btn>-->
        <!--                        </div>-->
        <!--                        <v-text-field-->
        <!--                                style="width: 200px;"-->
        <!--                                class="mt-1 nolabel"-->
        <!--                                v-model="captchaInput"-->
        <!--                                clearable-->
        <!--                                :maxlength="4"-->
        <!--                                placeholder="Hier eingeben"-->
        <!--                                illed hide-details-->
        <!--                        ></v-text-field>-->
        <!--                        <div>-->
        <!--                            <v-btn class="mt-4 orderBtn"-->
        <!--                                   color="green"-->
        <!--                                   v-if="captchaInput.length===4"-->
        <!--                                   dark-->
        <!--                                   block-->
        <!--                                   @click.native.passive="weiter">-->
        <!--                                <v-icon left class="">mdi-send</v-icon>-->
        <!--                                Los geht's-->
        <!--                            </v-btn>-->
        <!--                        </div>-->

        <!--                    </div>-->


        <!--                </div>-->

      </div>

    </v-container>

    <tischnummer-dialog :dialog="showTischnummer"
                        @tnumberselected="tnumberselected"
                        @close="showTischnummer = false"></tischnummer-dialog>

    <!--        <FrageStellenDialog-->
    <!--                :dialog="showFrageDialog"-->
    <!--                @stellefrage="doStellefrage"-->
    <!--        ></FrageStellenDialog>-->
  </div>
</template>

<script>
import * as appManager from '@/vendor/appManager'
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as xhr from '../api/xhr.js'
import * as util from '../vendor/util'
import * as qconst from '../vendor/qconstants';
import TischnummerDialog from "../dialogs/TischnummerDialog";
import BrandButton from "../components/BrandButton";
import CategoryCard from "../components/CategoryCard";
import {getGlobalValue, getGlobalValueOrZero, removeGlobalKey, setGlobalKeyValue} from "@/util/globalState";
import {clearEvents} from "../vendor/util";
import {getErrorDetails} from "@/util/globalErrorHandler";

export default {
  components: {CategoryCard, BrandButton, TischnummerDialog},
  data() {
    return {
      currentStep: 1,
      selectedService: '',

      captchaInput: '',

      showTischnummer: false,
      showFrageDialog: false,
    }
  },

  // mounted() {
  //     this.reloadCaptcha();
  // },

  mounted() {
    this.selectedService = '';
    this.currentStep = 1;
    this.captchaInput = '';
    if (this.checkEnter()) {
      this.reloadCaptcha();
    }
  },

  created() {
    ebus.$on('finishedRating', (name) => {
      try {
        let payOption = '' + getGlobalValue('ratingFeedbackContext');
        removeGlobalKey('ratingFeedbackContext');
        store.commit('showLoading', true);
        this.$store.commit('showDialogContainer', false);
        this.$store.commit('selectedDialog', '');
        setTimeout(() => {
          this.signal(payOption);
        }, 400);
        // setTimeout(() => {
        //   store.commit('showLoading', false);
        // }, 800);
      } catch (e) {

      }
    });
  },

  destroyed() {
    clearEvents([
      'finishedRating',
    ]);
  },

  methods: {

    clickPayOption(option) {
      if (store.state.enableRatingFeedback) {
        setGlobalKeyValue('ratingFeedbackContext', '' + option);
        this.$store.commit('selectedDialog', 'RatingFeedback');
        this.$store.commit('showDialogContainer', true);
      } else {
        this.signal(option);
      }
    },

    lazyShowWartung() {
      let uinfo = store.getters.appconfig.userInfo;
      if (uinfo) {
        ebus.$emit('showInfo', {
          title: '' + uinfo,
          text: ''
        });

        let uil = uinfo.toLowerCase();
        if (uil.indexOf('wartung') !== -1 || uil.indexOf('maintenance') !== -1) {
          ebus.$emit('loadAppconfig');
          return true;
        }
      }
      return false;
    },
    checkEnter() {
      if (!store.getters.inhouse) {
        ebus.$emit('gotoStart');
        return false;
      }

      if (this.lazyShowWartung()) {
        return false;
      }

      if (qconst.forceTableScan) {

        if (this.$store.getters.table > 0) {
          // store.commit('table',this.$store.getters.table);
          return true;
        } else {
          if (qconst.enableFlexCodes) {
            let fs = appManager.getTableFlexState(this.$ls.get('tableFlex'));
            if (fs === 3) {
              ebus.$emit('suggestQrCodeScan');
              return false;
            } else if (fs === 1) {
              return true;
            }
          } else {
            ebus.$emit('suggestQrCodeScan');
            return false;
          }
        }

      }

      return true;
    },

    doStellefrage(frage) {
      this.showFrageDialog = false;
      this.signal(frage);
    },

    askQuestion() {
      if (this.checkEnter()) {
        this.showFrageDialog = true;
      }
    },

    signal(type) {
      if (!type || 'undefined' === 'type') {
        return;
      }
      if (this.checkEnter()) {
        this.selectedService = type;
        // this.currentStep = 2;
        this.weiter();
      }
    },

    weiter() {
      if (qconst.forceTableScan) {
        if (qconst.enableFlexCodes) {
          let fs = appManager.getTableFlexState(this.$ls.get('tableFlex'));
          if (fs === 3) {
            ebus.$emit('suggestQrCodeScan');
            return false;
          } else if (fs === 1) {
            this.showTischnummer = true;
            return;
          }
        }

        if (this.$store.getters.table > 0) {
          // store.commit('table',this.$store.getters.table);
          this.doSignal();
        } else {
          ebus.$emit('suggestQrCodeScan');
        }
      } else {
        this.showTischnummer = true;
      }
    },

    tnumberselected(num) {
      ebus.$emit('userEnteredTable', num);
      this.doSignal();
    },

    doSignal() {
      let now = Date.now();
      let easer = getGlobalValueOrZero('doSignal');
      if (!easer || now - parseInt(easer) > 5 * 1000) {
        setGlobalKeyValue('doSignal', now);
      } else {
        //eased
        return;
      }

      store.commit('showLoading', true);
      let msg = {
        action: qconst.action$Kellnerruf,
        usecase: qconst.usecase$kellnerruf,
        type: this.selectedService,
        table: store.getters.table,
        signalId: util.generateClientId(),
        // captchaText: '' + this.captchaInput,
      };
      xhr.xhrSend(true, msg, (reply) => {
        store.commit('showLoading', false);
        if (reply.ok) {
          this.$router.replace({name: 'KellnerrufErfolgreich'});
        } else if (reply.forceReload) {
          alert('Hinweis: Nach einer kurzen Aktualisierung der App, die automatisch durchgeführt wird,' +
            ' kannst du den Kellnerruf wiederholen.');
          ebus.$emit('forceReload');
        } else if (reply.secTokenError) {
          ebus.$emit('forceReload');
        } else if (reply.captchaError) {
          ebus.$emit('info', 'Der eingegebenen Buchstaben sind ungültig.', 'Bitte gib die Buchstaben im letzen Schritt erneut ein!');
        } else {
          ebus.$emit('info', 'Die Kasse antwortet nicht. Bitte versuche es erneut!');
        }
        if (!reply.ok) {
          this.reloadCaptcha();
        }
      }, (err) => {
        store.commit('showLoading', false);
        console.log('error in Kellnerruf: ' + e);
      });
    },

    reloadCaptcha() {
      // // store.commit('showLoading', true);
      // this.generateCaptcha((responseOrFalse) => {
      //     if (responseOrFalse) {
      //         this.renderCaptcha(responseOrFalse);
      //     }
      //     this.captchaInput = '';
      //     // store.commit('showLoading', false);
      // });
    },

    async renderCaptcha(arrayBuffer) {
      try {
        // Obtain a blob: URL for the image data.
        let arrayBufferView = new Uint8Array(arrayBuffer);
        let blob = new Blob([arrayBufferView], {type: "image/jpeg"});
        let urlCreator = window.URL || window.webkitURL;
        let imageUrl = urlCreator.createObjectURL(blob);
        let img = document.getElementById("captchaUmage");
        if (imageUrl && img) {
          this.$nextTick(() => {
            img.src = imageUrl;
          });
        }


        // let img = new Image();
        // // let response = base64Buffer;
        // // let binary = '';
        // // for (let i = 0; i < response.length; i++) {
        // //     binary += String.fromCharCode(response.charCodeAt(i) & 0xff);
        // // }
        //
        // // img.src = 'data:image/jpeg;base64,' + btoa(binary);
        // img.src = 'data:image/jpeg;base64,' + base64Buffer;
        // let canvas = document.getElementById('captchaUmage');
        //
        // let context = canvas.getContext('2d');
        // this.$nextTick(() => {
        //     context.drawImage(img, 0, 0);
        // });
      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('error in drawCaptcha: ' + e.message));
        console.log('error in drawCaptcha: ' + e.message);
      }
    },

    generateCaptcha(cb) {
      xhr.xhrGetImage('xhr/captcha/generate',
        // {
        //     'Accept': '*/*'
        // },
        (reponseData) => {
          if (cb) {
            cb(reponseData);
          }
        },
        (err) => {
          if (cb) {
            cb(false);
          }
        }
      );
    },
  }
}
</script>

<style scoped lang="scss">
@import '../styles/base';

.page ::v-deep .v-text-field .v-input__slot {
  overflow: hidden;
  background-color: white;
  border: 1px solid #666;
  border-radius: $box-border-radius;
  /*min-height: 60px;*/
  padding: 6px 0 6px 10px;
}


.page ::v-deep .v-input {
  font-size: $fontSize;
}

.page ::v-deep .v-input__append-inner {
  margin-top: 4px;
}

.page ::v-deep .v-text-field .v-label {
  top: 20px;
}

.page ::v-deep input {
  padding: 14px 0 0 0;
}


.page .nolabel ::v-deep input {
  padding: 0;
  margin: 7px 4px 7px 0;
}


.page ::v-deep .v-input__slot:before {
  border: none;
}

.page ::v-deep .v-input__append-inner {
  margin-top: 6px;
}

/*.page ::v-deep .v-select__selections input {*/
/*    padding: 0;*/
/*    margin: 7px 4px 7px 0;*/
/*}*/


</style>
